import React, { useState, useEffect } from 'react';
import ModalPortal from 'components/Modal';
import { ModalApagarTarjeta } from 'pages/Credito/7-Modals';
import { getCardStatus } from 'services/Cards'
import { useIsMobile } from 'hooks/useIsMobile';

import { dataLayerButtons } from 'functions/dataLayerFunction'


export function CheckStatusCard(props){
    const {
        dataSaldos
    } = props
    const { isMobile } = useIsMobile();

    const [showModalApagarTarjeta, SetShowModalApagarTarjeta] = useState(false);
    const [prender, setPrender] = useState(false);

    // cerrar modal de tarjeta duplicada
    const handleClose = () => SetShowModalApagarTarjeta(false);

    useEffect(()=>{
        if(dataSaldos){
            if(dataSaldos.status === 1){
                setPrender(true)
            }
            else if(dataSaldos.status === 0){
                setPrender(false)
            }
        }
    },[dataSaldos])

    // realiza encendio / apagado de la tarjeta
    const [responseActive, setResponseActive] = useState()
    const handlePrenderApagar = () => {
        setPrender(!prender);
        if (prender === true) {
            SetShowModalApagarTarjeta(true);
        }
        else{
            getCardStatus({dataCard:{cardending: dataSaldos.cardending, no_internet: dataSaldos.noInternet, active: 1 }})
            .then(setResponseActive)
        }
    };
    // no deseo  apagar la tarjeta (modal)
    const noRemove = () => {
        SetShowModalApagarTarjeta(false);
        setPrender(true)
    };
    
    // si deseo  apagar la tarjeta (modal)
    const siRemove = () => {
        SetShowModalApagarTarjeta(false);
        getCardStatus({dataCard:{cardending: dataSaldos.cardending, no_internet: dataSaldos.noInternet, active: 0 }})
        .then(setResponseActive)
        setPrender(false)
    };

    useEffect(()=>{
        if(responseActive){
            if(prender){
                dataLayerButtons({eventName: "credito_prender"})
                //console.log('prender')
            }else{
                dataLayerButtons({eventName: "credito_apagar"})
                //console.log('apagar')
            }
        }
    },[responseActive])

    return(
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ?
                        <div className="boxApagarDesk">
                            <label htmlFor="prender" className="prender">{prender === true ? "Apagar tarjeta temporalmente" : "Prender tarjeta"}</label>
                            <label className="swich">
                                <input id="prender" type="checkbox" className="input" checked={prender} onChange={handlePrenderApagar}></input>
                                <div className="toggle">
                                    <span className="selector"></span>
                                </div>
                            </label>
                        </div>
                    :
                        <div className="opcApagar">
                            <span>{prender === true ? "Apagar" : "Prender"}</span>
                            <label>
                                <input type="checkbox" className="input" checked={prender} onChange={handlePrenderApagar}></input>
                                <div className="toggle">
                                    <span className="selector"></span>
                                </div>
                            </label>
                        </div>
                : null
            }
            
            {showModalApagarTarjeta &&
                <ModalPortal type="modalSB" onClose={handleClose} >
                    <ModalApagarTarjeta remvoeAction={siRemove} awaitAction={noRemove}
                        title="Apagar tarjeta"
                        body="Si no encuentras tu tarjeta física, puedes apagar tu tarjeta y evitarás que se realicen cargos. Podrás encenderla en cualquier momento."
                        subBody="¿Deseas apagarla temporalmente?" />
                </ModalPortal>
            }
        </>
    )
}